import angular from 'angular'

import component from './input-tooltip.component'

let module = angular.module('inputTooltipModule', [])

.component('inputTooltip', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/input-tooltip/index.js